import { Component, OnInit } from '@angular/core';

declare var RDStationForms: any;

@Component({
  selector: 'app-empreendedorismo',
  templateUrl: './empreendedorismo.component.html',
  styleUrls: ['./empreendedorismo.component.css']
})
export class EmpreendedorismoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    new RDStationForms('aditt-empreendedorismo-71ee8b49f179a9dd2ea0', 'UA-2727336-2').createForm();

    setTimeout(() => {
      this.openTab({ source: document.getElementById("btnItens") }, 'Itens');
    }, 500);

  }

  openTab(evt, cityName) {
    console.log(evt);
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }
    document.getElementById(cityName).style.display = "block";
    document.getElementById(`btn${cityName}`).classList.add('active');
  }

}
